const GoogleIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.7998 18.2652C28.7998 17.5212 28.7278 16.7532 28.6078 16.0332H18.2158V20.2812H24.1678C23.9278 21.6492 23.1358 22.8492 21.9598 23.6172L25.5118 26.3772C27.5998 24.4332 28.7998 21.6012 28.7998 18.2652Z"
      fill="#4280EF"
    />
    <path
      d="M18.216 29.0167C21.192 29.0167 23.688 28.0327 25.512 26.3527L21.96 23.6167C20.976 24.2887 19.704 24.6727 18.216 24.6727C15.336 24.6727 12.912 22.7287 12.024 20.1367L8.37598 22.9447C10.248 26.6647 14.04 29.0167 18.216 29.0167Z"
      fill="#34A353"
    />
    <path
      d="M12.0241 20.1126C11.5681 18.7446 11.5681 17.2566 12.0241 15.8886L8.37605 13.0566C6.81605 16.1766 6.81605 19.8486 8.37605 22.9446L12.0241 20.1126Z"
      fill="#F6B704"
    />
    <path
      d="M18.216 11.3528C19.776 11.3288 21.312 11.9288 22.44 13.0088L25.584 9.84079C23.592 7.96879 20.952 6.96079 18.216 6.98479C14.04 6.98479 10.248 9.33679 8.37598 13.0568L12.024 15.8888C12.912 13.2728 15.336 11.3528 18.216 11.3528Z"
      fill="#E54335"
    />
  </svg>
);

export default GoogleIcon;
